import { useNavigate } from 'react-router-dom';

export default function Terms() {
  const navigate = useNavigate();
  const s: any = {
    wrap: { background: '#0F1117', minHeight: '100vh', color: '#E8ECF4', padding: '40px 24px' },
    inner: { maxWidth: 800, margin: '0 auto' },
    h1: { color: '#E8ECF4', fontSize: 24, fontWeight: 800, marginBottom: 8 },
    h2: { color: '#00D4AA', fontSize: 16, fontWeight: 700, margin: '32px 0 12px' },
    p: { color: '#8892A4', fontSize: 14, lineHeight: 1.8, marginBottom: 12 },
  };

  return (
    <div style={s.wrap}>
      <div style={s.inner}>
        <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', color: '#8892A4', fontSize: 13, cursor: 'pointer', marginBottom: 24 }}>← 뒤로가기</button>
        <h1 style={s.h1}>이용약관</h1>
        <p style={{ ...s.p, color: '#4A5568' }}>시행일: 2026년 3월 22일</p>

        <h2 style={s.h2}>제1조 (목적)</h2>
        <p style={s.p}>
          본 약관은 진리커뮤니티(이하 "회사")가 운영하는 셀러랭키(sellerranky.kr, 이하 "서비스")의
          이용 조건 및 절차, 회사와 이용자 간의 권리·의무를 규정함을 목적으로 합니다.
        </p>

        <h2 style={s.h2}>제2조 (정의)</h2>
        <p style={s.p}>
          • "서비스"란 회사가 제공하는 네이버 쇼핑 순위 조회, 키워드 분석, 플레이스 순위,
          마케팅 전략 등 일체의 온라인 서비스를 말합니다.<br />
          • "이용자"란 본 약관에 동의하고 서비스를 이용하는 회원 및 비회원을 말합니다.<br />
          • "유료 서비스"란 월간/연간 구독을 통해 이용 가능한 프리미엄 기능을 말합니다.
        </p>

        <h2 style={s.h2}>제3조 (약관의 효력 및 변경)</h2>
        <p style={s.p}>
          본 약관은 서비스 화면에 게시함으로써 효력이 발생합니다.
          회사는 필요 시 약관을 변경할 수 있으며, 변경 시 적용일 7일 전 공지합니다.
          변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 탈퇴할 수 있습니다.
        </p>

        <h2 style={s.h2}>제4조 (서비스 이용)</h2>
        <p style={s.p}>
          • 서비스는 연중무휴 24시간 제공을 원칙으로 합니다.<br />
          • 시스템 점검, 장애 등 불가피한 경우 서비스가 일시 중단될 수 있습니다.<br />
          • 회사는 서비스 내용을 변경하거나 종료할 수 있으며, 이 경우 사전 공지합니다.<br />
          • 비회원도 일부 화면을 열람할 수 있으나, 실제 기능 사용은 회원가입이 필요합니다.
        </p>

        <h2 style={s.h2}>제5조 (회원가입 및 계정 관리)</h2>
        <p style={s.p}>
          • 이용자는 정확한 정보를 제공하여 회원가입을 신청해야 합니다.<br />
          • 타인의 정보를 도용하거나 허위 정보를 등록할 경우 서비스 이용이 제한됩니다.<br />
          • 계정은 본인만 사용할 수 있으며, 타인에게 양도·대여할 수 없습니다.<br />
          • 계정 도용 등 보안 문제 발생 시 즉시 회사에 통보해야 합니다.
        </p>

        <h2 style={s.h2}>제6조 (유료 서비스 및 구독)</h2>
        <p style={s.p}>
          • 유료 서비스는 Basic(월 13,900원), Pro(월 29,900원) 플랜으로 제공됩니다.<br />
          • 연간 결제 시 각각 15%, 20% 할인이 적용됩니다.<br />
          • 구독은 만료일에 자동으로 갱신되며, 갱신 3일 전 이메일로 안내합니다.<br />
          • 자동 갱신을 원하지 않으시면 만료일 전 마이페이지에서 취소해 주세요.<br />
          • 구독 취소 시 현재 결제 기간 만료일까지 서비스를 정상 이용할 수 있습니다.
        </p>

        <h2 style={s.h2}>제7조 (환불 정책)</h2>
        <p style={s.p}>
          • 월간 구독: 결제 후 환불이 불가하며, 취소 시 만료일까지 이용 가능합니다.<br />
          • 연간 구독: 결제 후 7일 이내 전액 환불 가능합니다 (전자상거래법 제17조).<br />
          • 연간 구독 7일 초과 시: 환불이 불가하며, 취소 후 만료일까지 이용 가능합니다.<br />
          • 환불 문의: sellerranky@gmail.com
        </p>

        <h2 style={s.h2}>제8조 (이용자 의무)</h2>
        <p style={s.p}>
          이용자는 다음 행위를 해서는 안 됩니다.<br />
          • 타인의 계정 도용 또는 개인정보 침해<br />
          • 서비스의 정상적인 운영을 방해하는 행위 (크롤링, DDoS 등)<br />
          • 서비스를 통해 수집한 데이터의 무단 상업적 이용<br />
          • 관련 법령 위반 행위
        </p>

        <h2 style={s.h2}>제9조 (서비스 이용 제한)</h2>
        <p style={s.p}>
          회사는 이용자가 본 약관을 위반하거나 서비스의 정상적인 운영을 방해하는 경우
          사전 통보 없이 서비스 이용을 제한하거나 계정을 정지할 수 있습니다.
        </p>

        <h2 style={s.h2}>제10조 (면책조항)</h2>
        <p style={s.p}>
          • 회사는 천재지변, 네트워크 장애 등 불가항력으로 인한 서비스 중단에 대해 책임지지 않습니다.<br />
          • 서비스에서 제공하는 데이터(순위, 키워드 등)는 참고용이며, 이를 기반으로 한
          투자·사업 결정의 결과에 대해 회사는 책임지지 않습니다.<br />
          • 이용자가 서비스를 통해 기대하는 수익을 보장하지 않습니다.
        </p>

        <h2 style={s.h2}>제11조 (분쟁 해결)</h2>
        <p style={s.p}>
          본 약관과 관련한 분쟁은 대한민국 법률에 따라 처리되며,
          분쟁 발생 시 회사 소재지 관할 법원을 전속 관할 법원으로 합니다.
        </p>

        <h2 style={s.h2}>제12조 (문의)</h2>
        <p style={s.p}>
          서비스 이용 관련 문의사항은 아래로 연락해 주세요.<br />
          • 이메일: sellerranky@gmail.com<br />
          • 상호: 진리커뮤니티 | 대표: 김성현<br />
          • 주소: 전북특별자치도 전주시 덕진구 기린대로 945-6, 경제통상진흥원 소상공인희망센터 107호
        </p>

        <div style={{ borderTop: '0.5px solid #2A3045', marginTop: 40, paddingTop: 20 }}>
          <p style={{ ...s.p, fontSize: 12 }}>시행일: 2026년 3월 22일 | 진리커뮤니티</p>
        </div>
      </div>
    </div>
  );
}
